module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d2def3685a9cd9760e2869888f8c7ac0.png";